import { RED_700, SIZING_6 } from '@mnd-frontend/ui/shared/tokens';
import type { ReactNode } from 'react';
import styled from 'styled-components';

const Container = styled.span`
  display: grid;
  align-items: center;
  justify-content: center;
  background: ${RED_700};
  border-radius: 50%;
  color: #FFFFFF;
  flex-shrink: 0;
  height: ${SIZING_6};
  width: ${SIZING_6};
  pointer-events: none;
`;

const IconBadge = ({ icon }: { icon: ReactNode }) => {
  return <Container>{icon}</Container>;
};

export default IconBadge;
